module.exports = __webpack_public_path__ + "img/banner-faq.45ffcf15.jpg";